// src/api/userApi.js
import API_BASE_URL from '../config/apiConfig';

export const registerUser = (user) => {
    return API_BASE_URL.post('/users/register', user);
};

export const loginUser = (credentials) => {
    return API_BASE_URL.post('/users/login', credentials);
};

export const forgotPassword = (email) => {
    return API_BASE_URL.post('/users/forgot-password', {
        email
    });
};

export const resetPassword = (data) => {
    return API_BASE_URL.post('/auth/reset-password', data);
};

export const changePassword = (data) => {
    return API_BASE_URL.post('/users/change-password', data);
};

export const verifyEmail = (token) => {
    return API_BASE_URL.get(`/auth/verify-email?token=${token}`);
};